var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrow = function SvgArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 48,
    viewBox: "0 0 28 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0464 8.00096C10.0821 7.93969 11.301 10.8411 12.3189 10.8986C16.8366 11.1833 20.9558 13.308 23.1113 17.4052C24.8175 20.6389 25.3518 24.6888 24.4807 28.2341C22.4258 36.393 13.7139 41.0102 5.67096 40.7482C7.15176 39.8777 8.61576 38.9222 9.93884 37.8041C10.7519 37.0995 8.94487 34.423 8.26301 34.9996C5.86455 37.0782 3.03196 38.508 0.260606 40.0413C-0.50852 40.4515 0.636172 42.1502 0.980885 42.4494C3.71094 44.9097 7.02097 46.725 10.4817 47.9256C11.7316 48.3658 10.5441 45.4513 9.65899 45.1364C8.40912 44.6963 7.16467 44.1802 5.9793 43.5845C13.6325 44.2839 21.578 40.5729 25.2432 33.6808C28.5377 27.4943 26.7916 19.2698 22.5336 13.9623C19.6795 10.3568 15.6491 8.26882 11.0464 8.00096Z",
    fill: "#202020"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow.b36b65b6.svg";
export { ForwardRef as ReactComponent };